import { FC, ReactNode } from "react";

interface Props {
	title: string;
	description?: ReactNode;
	tone?: "neutral" | "warn";
}

const EmptyState: FC<Props> = ({ title, description, tone = "neutral" }) => {
	const toneClass =
		tone === "warn"
			? "border-amber-200 bg-amber-50 text-amber-900"
			: "border-border bg-subtle text-muted-foreground";
	return (
		<div className={`rounded-xl border p-6 text-sm ${toneClass}`} role="status">
			<p className="font-medium text-foreground">{title}</p>
			{description ? (
				<p className="mt-1 text-sm text-muted-foreground">{description}</p>
			) : null}
		</div>
	);
};

export default EmptyState;
